import { Component, ChangeDetectionStrategy, HostBinding } from "@angular/core";

@Component({
    selector: "sps-summary-list-expansion",
    templateUrl: "./sps-summary-list-expansion.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsSummaryListExpansionComponent {
    static readonly displayName = "sps-summary-list-expansion";
    static readonly props = {};
    @HostBinding("class.sps-content-row__expansion") readonly mainClass = true;
}
